import request from '@/http/request'
import {
    getSignNumber,
    getRealTimePay,
    getScoreDistribution,
    getQRCodeData,
    judgeIsViewPay,
    getHomePagePlanList,
    getExamCount,
    getSignDoD,
    getSignDateCount,
    getAuditCount,
    getAuditDateCount,
    getPayCount,
    getPayDateCount,
    getDownloadEntranceCount,
    getDownloadEntranceDateCount,
    getJudgeCount,
    getScoreCount,
    getSmartReminder
} from '@/http/api'

// 智能提醒
export const getSmartReminderApi = (data) => {
    return request({
        url: getSmartReminder,
        data
    })
}

// 首页成绩
export const getScoreCountApi = (data) => {
    return request({
        url: getScoreCount,
        data
    })
}

// 首页阅卷
export const getJudgeCountApi = (data) => {
    return request({
        url: getJudgeCount,
        data
    })
}

// 首页准考证
export const getDownloadEntranceCountApi = (data) => {
    return request({
        url: getDownloadEntranceCount,
        data
    })
}
export const getDownloadEntranceDateCountApi = (data) => {
    return request({
        url: getDownloadEntranceDateCount,
        data
    })
}
// 首页缴费
export const getPayCountApi = (data) => {
    return request({
        url: getPayCount,
        data
    })
}
export const getPayDateCountApi = (data) => {
    return request({
        url: getPayDateCount,
        data
    })
}
// 首页审核
export const getAuditDateCountApi = (data) => {
    return request({
        url: getAuditDateCount,
        data
    })
}
export const getAuditCountApi = (data) => {
    return request({
        url: getAuditCount,
        data
    })
}
// 首页报名
export const getSignDateCountApi = (data) => {
    return request({
        url: getSignDateCount,
        data
    })
}
export const getSignDoDApi = (data) => {
    return request({
        url: getSignDoD,
        data
    })
}
// 首页考试
export const getExamCountApi = (data) => {
    return request({
        url: getExamCount,
        data
    })
}

export const getHomePagePlanListApi = (data) => {
    return request({
        url: getHomePagePlanList,
        data
    })
}

export const getSignNumberFn = (data) => {
    return request({
        url: getSignNumber,
        data
    })
}

export const judgeIsPay = () => {
    return request({
        url: judgeIsViewPay,
    })
}

export const getRealTimePayFn = (data) => {
    return request({
        url: getRealTimePay,
        data
    })
}

export const scoreData = (data) => {
    return request({
        url: getScoreDistribution,
        data
    })
}
export const getCodeImg = (data) => {
    return request({
        url: getQRCodeData,
        data
    })
}